/**
 * Dark-mode helpers for the SubmitTime react-select combos.
 *
 * The combos (Layer / Phases / Approver / custom fields) are styled via JS
 * `StylesConfig` objects and their menus are portaled to <body>, so plain CSS
 * (including SubmitTime.css dark rules) can't reach them. These helpers let the
 * style objects pick dark colors at render time.
 *
 * Both Web (`html.dark`) and Chat (`html.dark-mode-chat.dark`) carry the
 * `dark` class, so a single check covers both apps.
 */

export const isSubmitTimeDark = (): boolean =>
  typeof document !== 'undefined' &&
  document.documentElement.classList.contains('dark');

/** Shared dark palette (mirrors SubmitTime.css `html.dark` values). */
export const ST_DARK = {
  controlBg: '#3a3c3c',
  border: '#4a4c4c',
  borderFocus: '#62accb',
  text: '#a9a093',
  placeholder: '#6e6860',
  menuBg: '#333535',
  optionFocusBg: '#62accb',
  optionFocusText: '#fff',
  optionText: '#a9a093',
} as const;
